import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateFaRegisterPdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  assetRows,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [schedule, company, assetRows, notes, reviewNotes];
  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) => generateFaRegisterPdf(forView, ...sharedArgs)}
        downloadName='Fixed Asset Register'
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFaRegisterPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
